import axios from "axios";
import { toast } from "react-toastify";

let isLoggingOut = false;

const isInvalidRequester = (error) => {
  const response = error?.response;
  if (!response || response.status !== 401) return false;

  const data = response.data;
  const messages = data?.messages?.error_messages;

  return (
    Array.isArray(messages) &&
    messages.some(
      (msg) => String(msg).trim().toLowerCase() === "invalid requester"
    )
  );
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isInvalidRequester(error) && !isLoggingOut) {
      isLoggingOut = true;
      localStorage.clear();
      toast.error("Session expired. Redirecting to login...", {
        autoClose: 1500,
      });
      setTimeout(() => {
        window.location.replace("/");
      }, 1500);
    }

    return Promise.reject(error);
  }
);